import React from 'react';

export default ({ size = 10 }) => <div style={{ height: `${size}px` }} />;



// WEBPACK FOOTER //
// ./src/components/Space.js